import { createStandaloneToast } from "@chakra-ui/react";

export function NumberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

type SpecialWordsType = Record<string, string>;

const SPECIAL_WORDS: SpecialWordsType = {
  cpi: "CPI",
  kpi: "KPI",
  id: "ID",
};

export function toReadableName(snakeCaseString: string): string {
  return snakeCaseString
    .split("_")
    .map(
      (word) =>
        SPECIAL_WORDS[word] || word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
}

export function truncateString(input: string): string {
  const maxLength = 25;
  if (input.length <= maxLength) {
    return input;
  } else {
    return input.slice(0, maxLength - 3) + "...";
  }
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
  });
};

export function extractPackageName(url: string) {
  try {
    const parsedUrl = new URL(url);
    const packageName = parsedUrl.searchParams.get("id");

    return packageName;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}

export function extractIosAppId(url: string) {
  try {
    const parsedUrl = new URL(url);
    const pathSegments = parsedUrl.pathname.split("/");
    const idSegment = pathSegments.find((segment) => segment.startsWith("id"));
    if (idSegment) {
      const appId = idSegment.substring(2);
      return appId;
    }
    console.error("No iOS app ID found in the URL");
    return null;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}

export function extractAdjustTrackerId(url: string) {
  const parsedUrl = new URL(url);
  const pathname = parsedUrl.pathname;
  const segments = pathname.split("/");
  const adjustTrackerId = segments.length > 1 ? segments[1] : null;

  return adjustTrackerId;
}

export function handleCopyValue(value: string) {
  const toast = createStandaloneToast();

  if (!navigator.clipboard) {
    toast({
      title: "Your browser does not support clipboard.",
      status: "error",
      duration: 2000,
      isClosable: true,
    });
  }
  navigator.clipboard.writeText(value || "");
}
